import ObjectHelper from '~/helpers/ObjectHelper';



export default class Notify {
  public static SUCCESS_MESSAGE_STORAGE_KEY ='showSuccessMessage';

  private readonly note: HTMLElement;
  private readonly container: HTMLElement;
  private options = {
    type: 'success',
    containerClass: 'notifications',
    closable: true,
    fadeOut: {
      enabled: true,
      delay: 5000,
    },
    message: '',
    onClose: () => {},
    onClosed: () => {},
  };

  static notify(options = {}): Notify {
    const notification = new Notify(options);
    notification.show();
    return notification;
  }

  static error(message: string, options = {}): Notify {
    return this.notify({ message, type: 'danger', ...options });
  }

  static success(message: string, options = {}): Notify {
    return this.notify({ message, ...options });
  }

  constructor(options = {}) {
    ObjectHelper.updateByObject(this.options, options);
    this.container = this.getOrCreateContainer();
    this.note = this.createElement('div', ['alert', `alert-${this.options.type}`, 'in', 'fade', 'show']);
    this.note.setAttribute('role', 'alert');
    this.note.innerHTML = this.options.message;
    if (this.options.closable) {
      this.addCloseIcon();
      this.note.classList.add('alert-dismissible');
    }
  }

  show() {
    this.closeDuplicate();
    this.container.append(this.note);
    if (this.options.fadeOut.enabled) {
      setTimeout(() => this.hide(), this.options.fadeOut.delay);
    }
  }

  hide() {
    this.note.style.opacity = '0';
    this.note.addEventListener('transitionend', () => this.onClose());
  }

  private onClose() {
    this.options.onClose();
    this.note?.remove();
    this.options.onClosed();
  }

  private getOrCreateContainer(): HTMLElement {
    const elements = document.getElementsByClassName(this.options.containerClass);
    if (elements.length) {
      return elements[0] as HTMLElement;
    } else {
      const element = this.createElement('div', [this.options.containerClass]);
      document.body.append(element);
      return element;
    }
  }

  private createElement(tagName: string, classes: string[]): HTMLElement {
    const element = document.createElement(tagName);
    element.classList.add(...classes);
    return element;
  }

  private addCloseIcon() {
    const link = this.createElement('button', ['btn-close']);
    link.setAttribute('data-bs-dismiss', 'alert');
    link.setAttribute('aria-labe', 'Close');
    link.addEventListener('click', () => this.onClose());
    this.note.append(link);
  }

  private closeDuplicate() {
    const selector = `.${this.options.containerClass} div`;
    //@ts-ignore
    this.container.querySelectorAll(selector).forEach((element) => {
      if (element instanceof HTMLDivElement) {
        if (element.style.opacity === '0' || element.innerHTML.includes(this.note.innerHTML)) {
          element.remove();
        }
      }
    });
  }
}
